import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({ standalone: false, 
  selector: 'cyborg-button',
  templateUrl: './cyborg-button.component.html',
  styleUrls: ['./cyborg-button.component.scss'],
})
export class CyborgButtonComponent {
  @Output() public onClick = new EventEmitter<MouseEvent>();
  @Input() public iconAlign: 'left' | 'right' = 'left';
  @Input() public color: 'primary' | 'secondary' | 'outline' | 'error';
  @Input() public size: 'small' | 'medium' | 'large';
  @Input() public icon: string;
  @Input() public disabled: boolean = false;

  @HostBinding('class.primary')
  public get primary(): boolean {
    return this.color == 'primary';
  }

  @HostBinding('class.secondary')
  public get secondary(): boolean {
    return this.color == 'secondary';
  }

  @HostBinding('class.outline')
  public get outline(): boolean {
    return this.color == 'outline';
  }

  @HostBinding('class.error')
  public get error(): boolean {
    return this.color == 'error';
  }

  @HostBinding('class.small')
  public get small(): boolean {
    return this.size == 'small';
  }

  @HostBinding('class.medium')
  public get medium(): boolean {
    return this.size == 'medium';
  }

  @HostBinding('class.large')
  public get large(): boolean {
    return this.size == 'large';
  }

  public onClickButton(event): void {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }
}
